import Layout from '@/views/layout'
export default {
  path: '/electric',
  menuName: '电子围栏',
  component: Layout,
  name: 'electric',
  meta: { title: 'E-CALL', icon: 'geofence', iconType: 'svg' },
  children: [
    {
      path: 'electricManage',
      name: 'electricManage',
      menuName: '电子围栏管理',
      component: () => import('@/views/electric/electricManage'),
      meta: { title: 'electricManage', icon: 'electricManage', iconType: 'svg' }
    },
    {
      path: 'geofence',
      name: 'geofence',
      menuName: '电子围栏管理',
      component: () => import('@/views/electric/geofence'),
      meta: { title: 'electricManage', icon: 'electricManage', iconType: 'svg' }
    },
    {
      path: 'electricNotes',
      name: 'electricNotes',
      menuName: '电子围栏报警记录',
      component: () => import('@/views/electric/electricNotes'),
      meta: { title: 'electricNotes', icon: 'electricNotes', iconType: 'svg' }
    },
    {
      path: 'geofenceRecords',
      name: 'geofenceRecords',
      menuName: '电子围栏报警记录',
      component: () => import('@/views/electric/geofenceRecords'),
      meta: { title: 'electricNotes', icon: 'electricNotes', iconType: 'svg' }
    }
  ]
}